// Yup test for a lead form's phone field (CU-869fnwgxf).
//
// Loads the phone library (./phoneCheck → libphonenumber-js/min, ~30 KB gzip) only the
// first time a phone field is validated, so it is not in the app's first-load bundle:
// validations.js is reachable from the app entry through the components barrel.
//
// Opt-in: it runs only when the form passes `context.initialPhoneNumber`
// (react-hook-form `useForm({ context })`), and it never refuses the number the form
// opened with, so editing another field of a lead whose old number is wrong still
// saves (the backend rule is the same).
export async function diallablePhoneTest(value) {
    const context = this?.options?.context;
    if (!context || !('initialPhoneNumber' in context)) return true;
    const strip = (v) => String(v ?? '').replace(/\s/g, '');
    if (strip(value) === strip(context.initialPhoneNumber)) return true;
    const { checkLeadPhone } = await import('./phoneCheck');
    const check = checkLeadPhone(value);
    if (!check || check.ok) return true;
    return this.createError({ message: check.message });
}
